import { composeWithDevTools } from '@redux-devtools/extension';
import throttle from 'lodash/throttle';
import { applyMiddleware, createStore } from 'redux';
import createDebounce from 'redux-debounced';
import thunk from 'redux-thunk';

import reducer from '../reducer';

import camelMiddleware from './camelcaseKeysMiddleware';
import logger from './loggerMiddleware';
import { loadFromLocalStorage, saveToLocalStorage } from './persistantStorageMiddlware';

const middleware = [thunk, camelMiddleware(), createDebounce()];
const persistedState = loadFromLocalStorage();

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger);
}

// applyMiddleware(...middleware) must be the last argument.
const store = createStore(
  reducer,
  persistedState,
  composeWithDevTools(
    applyMiddleware(...middleware)
  )
);

// listen for store changes and use saveToLocalStorage to
// save them to localStorage
store.subscribe(throttle(() => {
  saveToLocalStorage(store.getState());
}, 1000));

export default store;
